import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getStudioParams } from '../../../../selectors/studio';
import { illustrationUrl } from '../../StudioBlankSlate';
import UploadBlankSlate from '../../_partials/UploadBlankSlate';

const SUBSCRIPTIONS_IMG_URL = illustrationUrl('studio-subscriptions-empty.png', 0);

const TierBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const { tierId } = useSelector(getStudioParams);
  return (
    <UploadBlankSlate
      title={t('studio.blankSlate.tierDeviations.title')}
      subtitle={t('studio.blankSlate.tierDeviations.subtitle')}
      ctaLabel={t('studio.blankSlate.tierDeviations.ctaLabel')}
      illustrationSrc={SUBSCRIPTIONS_IMG_URL}
      linkToSubmit
      linkToSubmitParams={{ tierId }}
      noBorder
    />
  );
};
TierBlankSlate.displayName = 'TierBlankSlate';

export default TierBlankSlate;
